const CUSTOM_FIELDS_TYPES = [
    {
        label: 'Array',
        value: 'array',
        description: 'An array of strings up to 255 characters, maximum size is 1000 elements.',
    },
    {
        label: 'Boolean',
        value: 'boolean',
        description: 'A boolean data type is a data type with only two possible values: true or false.',
    },
    {
        label: 'Date',
        value: 'date',
        description: 'String of format "full date" (YYYY-MM-DD) from RFC-3339 (full-date).',
    },
    {
        label: 'Date & Time',
        value: 'datetime',
        description: 'String of format "date-time" (YYYY-MM-DDTHH:MM:SSZ) from RFC-3339 (date-time).',
    },
    {
        label: 'Integer',
        value: 'integer',
        description: 'An integer is a whole number (not a fractional number) that can be positive, negative, or zero.',
    },
    {
        label: 'Number',
        value: 'number',
        description: 'A floating point number. It can take cardinal values which are also interpreted as a floating point number.',
    },
    {
        label: 'String',
        value: 'string',
        description: 'Regular string up to 255 characters.',
    },
    {
        label: 'Monetary',
        value: 'monetary',
        description: 'A map of 3-letters currency codes and amount.',
    },
];

export default CUSTOM_FIELDS_TYPES;
